export default function getResource(label, vars = []) {
    const resources = {
        cardTitle: 'Paiement',
        expires: 'Exp.',
        useGiftCard: 'Utiliser une carte-cadeau',
        paypalRestrictedItemError: 'L’un des articles de votre panier ne peut pas être acheté avec Paypal. Veuillez supprimer l’article pour payer avec Paypal ou bien utilisez un autre mode de paiement pour passer à la caisse avec cet article.',
        giftCardNumber: 'Numéro de carte-cadeau',
        pin: 'NIP',
        applyBtn: 'Appliquer',
        cancelBtn: 'Annuler',
        maxGiftCards: 'Vous avez atteint le nombre maximal de cartes-cadeaux que vous pouvez utiliser pour cette commande.',
        giftCard: 'Carte-cadeau',
        applied: 'appliqué',
        remove: 'Supprimer',
        secure: 'Sûr',
        payPalAccount: 'Compte PayPal',
        payWithPayPal: 'Payer avec PayPal',
        payNow: 'Payez maintenant',
        or: 'ou',
        payLaterWithPayPal: 'Payez plus tard avec PayPal',
        payWithApplePay: 'Payer avec ApplePay',
        addNewCreditCard: 'Ajouter une nouvelle carte de crédit ou de débit',
        debitCardDisclaimer: 'Cartes de débit Visa et Mastercard seulement',
        payPalDisabled: 'PayPal ne peut pas être utilisé pour l’achat d’un abonnement.',
        verifyCVV: 'Aucun paiement n’est requis. Veuillez vérifier votre numéro CVV/CVC à des fins de sécurité.',
        accountCredit: 'Crédit au compte',
        giftCardsNotCombinable: 'Les cartes-cadeaux ne peuvent pas être combinées avec ce mode de paiement.',
        removeCreditCard: 'Supprimer la carte de crédit ou la carte de débit',
        areYouSureMessage: 'Voulez-vous vraiment supprimer cette carte de façon définitive?',
        removeGiftCard: 'Supprimer la carte-cadeau',
        areYouSureGiftCardMessage: 'Voulez-vous vraiment supprimer cette carte-cadeau de votre commande?',
        cancel: 'Annuler',
        expiredCreditCardMsg: 'Cette carte est expirée. Veuillez effectuer une mise à jour des renseignements de votre carte.',
        edit: 'Modifier',
        gotIt: 'Compris',
        cvc: 'CVV/CVC',
        moreInfoCvc: 'Plus d’informations relatives au CVC',
        storeCreditApplied: 'Crédit au compte',
        storeCreditNotEnoughMessage: 'Le solde de votre crédit au compte est inférieur au total de la commande. Veuillez ajouter un mode de paiement supplémentaire.',
        accountCreditAltText: 'Crédit au compte Sephora',
        paymentMethodSelection: 'Sélection du mode de paiement',
        paymentInformation: 'Informations sur le paiement',
        somePaymentCannotUsed: 'Certains modes de paiement ne peuvent pas être utilisés pour l’achat d’un abonnement.',
        removeAddress: 'Supprimer l’adresse',
        maxCreditCardsMessage: `Vous pouvez avoir jusqu’à ${vars[0]} cartes de crédit. Veuillez en supprimer une et en ajouter une autre à nouveau.`,
        continueButton: 'Continuer',
        editPaypal: 'Modifier'
    };
    return resources[label];
}
